import { Injectable } from '@angular/core';
import { map, Observable, ReplaySubject, startWith } from 'rxjs';
import { InternalPrompt } from '@panaya/ai-chat/shared';

@Injectable({
    providedIn: 'root'
})
export class AiChatInternalPromptService {
    public readonly internalPrompt$: Observable<InternalPrompt>;
    public readonly shouldShowLoading$: Observable<boolean>;
    private readonly internalPromptSubject = new ReplaySubject<InternalPrompt>(1);

    constructor() {
        this.internalPrompt$ = this.internalPromptSubject.asObservable();
        this.shouldShowLoading$ = this.internalPrompt$.pipe(
            map(({ showLoading }: InternalPrompt) => !!showLoading),
            startWith(false)
        );
    }

    public triggerInternalPrompt(prompt: InternalPrompt): void {
        this.internalPromptSubject.next(prompt);
    }
}
